import { createContext, use, useMemo, useState, type ReactNode } from "react";
import { createPortal } from "react-dom";

type HeaderSlotContextValue = {
    node: HTMLElement | null;
    setNode: (node: HTMLElement | null) => void;
};

const HeaderSlotContext = createContext<HeaderSlotContextValue | null>(null);

function useHeaderSlot() {
    return use(HeaderSlotContext);
}

export function HeaderSlotProvider({ children }: { children: ReactNode }) {
    const [node, setNode] = useState<HTMLElement | null>(null);
    const value = useMemo(() => ({ node, setNode }), [node]);

    return <HeaderSlotContext value={value}>{children}</HeaderSlotContext>;
}

export function HeaderSlotTarget(props: { className?: string }) {
    const ctx = useHeaderSlot();

    return <div ref={ctx?.setNode ?? null} {...props} />;
}

export function HeaderSlot({ children }: { children: ReactNode }) {
    const ctx = useHeaderSlot();

    return ctx?.node ? createPortal(children, ctx.node) : null;
}
